import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { StyledDescriptionBlock, StyledTitle } from './ProductDetailStyles'

const StyledDescription = styled.div`
  color: #475569;
  margin-bottom: 20px;
`

const WashLabelContainer = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  display: inline-block;
  background: #ffffff;

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`

const WashDescriptionBlock = ({ article, withTitle }) => {
  const { t } = useTranslation()
  const washLabelImage = article?.washLabel?.url || false
  const washLabelDescription = article?.washLabel?.description || ''
  const showWashDescription = washLabelDescription || washLabelImage

  if (!showWashDescription) {
    return null
  }

  return (
    <StyledDescriptionBlock>
      {withTitle && (
        <StyledTitle className='h1 mb-3'>
          {t('productDetail:materialAndCare')}
        </StyledTitle>
      )}

      {washLabelDescription && (
        <StyledDescription>{washLabelDescription}</StyledDescription>
      )}

      {washLabelImage && (
        <WashLabelContainer>
          <img src={washLabelImage} alt='Wash Label' />
        </WashLabelContainer>
      )}
    </StyledDescriptionBlock>
  )
}

export default WashDescriptionBlock
